import React from "react";
import "./layouts-styles.css";

const BaseBody = (props) => {
  const { children, className, contentClassName } = props;

  return (
    <div className={ ["site-page-wrapper base-body", className].filter(Boolean).join(" ") }>
      <div className={ ["site-layout-content base-body__content", contentClassName].filter(Boolean).join(" ") }>
        { children }
      </div>
    </div>
  );
};

export default BaseBody;
